import React from "react"
import { Box } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import CheckIcon from "@mui/icons-material/Check"


const useStyles = makeStyles(() => ({
  insideIcon: {
    borderRadius: "50%",
    width: 20,
    height: 20,
  },
  withMargin: {
    composes: "$insideicon",
    marginTop: -3,
  },
}))

function IconCheck({ color = "white", bgColor = "green", withMargin = false }) {
  const classes = useStyles()

  return (
    <Box display="flex" alignItems="center">
      <CheckIcon
        className={`${classes.insideIcon} ${withMargin ? classes.withMargin : ""}`}
        style={{ backgroundColor: bgColor, color }}
      />
    </Box>
  )
}

export default IconCheck